import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  spacing: 8,
  palette: {
    primary: {
      main: "#0021A5", // Your custom primary color
    },
    secondary: {
      main: "#FA4616", // Your custom secondary color
    },
    // You can also customize other colors here
  },
});

export default theme;
